var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrariBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9634 5.78401C17.2354 4.08001 14.9794 3.14401 12.5794 3.14401C12.5554 3.14401 12.5554 3.14401 12.5314 3.14401C10.0834 3.14401 7.77943 4.10401 6.07543 5.85601C4.37143 7.58401 3.43543 9.84001 3.45943 12.24C3.48343 17.28 7.56343 21.336 12.5314 21.336H12.5554C17.5714 21.312 21.6754 17.232 21.6754 12.216C21.6514 9.79201 20.7154 7.51201 18.9634 5.78401ZM12.5554 20.136C10.4434 20.136 8.45144 19.32 6.96344 17.808C5.47544 16.296 4.63543 14.352 4.65943 12.24C4.65943 10.128 5.49943 8.13601 6.98743 6.64801C8.47543 5.16001 10.4674 4.34401 12.5794 4.34401C16.9234 4.34401 20.4754 7.89601 20.4754 12.24C20.4514 16.608 16.9234 20.136 12.5554 20.136Z",
    fill: "url(#paint0_linear_250_318)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1153 15.96L16.2993 15.12C15.5313 14.352 14.7393 13.56 13.9473 12.768C13.7313 12.552 13.6353 12.432 13.7073 12.192C13.7313 12.12 13.7073 12.072 13.7073 12.048V12.024C13.7073 12 13.7073 11.976 13.7073 11.952C13.7073 11.904 13.7313 11.856 13.7313 11.832C14.0193 11.496 14.3073 11.184 14.6193 10.848L16.1313 9.16802C16.3233 8.95202 16.3713 8.68802 16.2273 8.49602C16.1313 8.35202 15.9393 8.18402 15.7233 8.18402C15.5073 8.18402 15.3153 8.30402 15.1953 8.44802C14.4273 9.28802 13.6353 10.152 12.8913 10.992C12.7713 11.112 12.7713 11.112 12.7473 11.088L12.7233 11.064H12.6993C12.3393 11.04 12.0273 11.16 11.7873 11.4C11.5473 11.616 11.4273 11.928 11.4513 12.24C11.4513 12.552 11.5953 12.864 11.8593 13.08C12.0993 13.296 12.4353 13.392 12.7473 13.344C12.8433 13.32 12.8913 13.344 12.9873 13.44C13.8993 14.352 14.8113 15.288 15.7473 16.2L16.3233 16.776C16.3713 16.824 16.4193 16.896 16.4913 16.944C16.5873 17.016 16.7313 17.064 16.8513 17.064C17.0193 17.064 17.1633 16.992 17.2833 16.896C17.4993 16.68 17.4993 16.344 17.3313 16.104C17.2353 16.056 17.1633 16.008 17.1153 15.96Z",
    fill: "url(#paint1_linear_250_318)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9556 6.55201C11.9796 6.88801 12.2196 7.12801 12.5316 7.12801C12.5316 7.12801 12.5316 7.12801 12.5556 7.12801C12.7236 7.12801 12.8676 7.08001 12.9636 6.96001C13.0836 6.84001 13.1316 6.69601 13.1556 6.52801C13.1556 6.14401 13.1556 5.76001 13.1556 5.40001C13.1556 5.06401 12.8916 4.82401 12.5796 4.82401C12.2436 4.82401 11.9796 5.06401 11.9796 5.42401C11.9796 5.54401 11.9796 5.68801 11.9796 5.80801V6.50401C11.9556 6.50401 11.9556 6.52801 11.9556 6.55201Z",
    fill: "url(#paint2_linear_250_318)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3954 11.64C19.2754 11.64 19.1314 11.64 19.0114 11.64H18.9874H18.4834C18.4114 11.64 18.3394 11.64 18.2914 11.64C17.9554 11.664 17.6914 11.88 17.6914 12.192C17.6914 12.36 17.7394 12.528 17.8594 12.648C17.9794 12.768 18.1234 12.84 18.2914 12.84C18.4834 12.84 18.6754 12.84 18.8674 12.84C19.0594 12.84 19.2514 12.84 19.4194 12.84C19.7554 12.84 20.0194 12.576 20.0194 12.24C19.9714 11.904 19.7314 11.664 19.3954 11.64Z",
    fill: "url(#paint3_linear_250_318)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1556 17.952C13.1316 17.616 12.8916 17.376 12.5796 17.376C12.4116 17.376 12.2676 17.424 12.1476 17.544C12.0276 17.664 11.9556 17.808 11.9556 17.976C11.9556 18.36 11.9556 18.744 11.9556 19.104C11.9556 19.44 12.1956 19.68 12.5316 19.704C12.5316 19.704 12.5316 19.704 12.5556 19.704C12.8916 19.704 13.1316 19.464 13.1556 19.104C13.1556 18.984 13.1556 18.84 13.1556 18.72V18.552V18.384C13.1556 18.216 13.1556 18.072 13.1556 17.952Z",
    fill: "url(#paint4_linear_250_318)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79523 11.64C6.43523 11.64 6.05123 11.64 5.69123 11.64C5.54723 11.64 5.40323 11.712 5.28323 11.808C5.18723 11.928 5.11523 12.096 5.11523 12.24C5.11523 12.552 5.37923 12.816 5.71523 12.816H6.74723C6.74723 12.816 6.74723 12.816 6.77123 12.816C6.79523 12.816 6.79523 12.816 6.81923 12.816C7.17923 12.792 7.41923 12.528 7.39523 12.192C7.39523 11.856 7.17923 11.64 6.79523 11.64Z",
    fill: "url(#paint5_linear_250_318)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_318",
    x1: 12.5672,
    y1: 3.14401,
    x2: 12.5672,
    y2: 21.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_250_318",
    x1: 14.45,
    y1: 8.18402,
    x2: 14.45,
    y2: 17.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_250_318",
    x1: 12.5556,
    y1: 4.82401,
    x2: 12.5556,
    y2: 7.12801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_250_318",
    x1: 18.8554,
    y1: 11.64,
    x2: 18.8554,
    y2: 12.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_250_318",
    x1: 12.5556,
    y1: 17.376,
    x2: 12.5556,
    y2: 19.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_250_318",
    x1: 6.25606,
    y1: 11.64,
    x2: 6.25606,
    y2: 12.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrariBlue);
export default __webpack_public_path__ + "static/media/orari_blue.6e5b1d50e6beab5068d3443b2da59b74.svg";
export { ForwardRef as ReactComponent };